import AdminAnalyticsPage from "@/pages/admin/analytics/page";

export default function SalesAnalyticsPage() {
  return <AdminAnalyticsPage audience="sales" />;
}
